import { useMemo } from "react";
import { FormFieldTypes } from "types/enums";

import { useFormFieldTypeLabel } from "./useFormFieldTypeLabel";

export const useFormFieldTypeSelectOptions = () => {
    const getLabel = useFormFieldTypeLabel();

    const options = useMemo(
        () => Object.values(FormFieldTypes).map((value) => ({ label: getLabel(value), value })),
        [getLabel]
    );

    return { options, loading: false, error: null };
};
